/** ADX enriched API → chart labels and markers. */

export const ADX_REGIME_LABELS = {
  range: 'Range',
  developing: 'Trend developing',
  developing_fading: 'Trend fading',
  strong: 'Strong trend',
  strong_weakening: 'Strong but weakening',
  trending_flat: 'Trending (flat ADX)',
};

export const ADX_REGIME_CLS = {
  range: 'regime-ranging',
  developing: 'regime-developing',
  developing_fading: 'regime-fading',
  strong: 'regime-strong',
  strong_weakening: 'regime-fading-strong',
  trending_flat: 'regime-developing',
};

export function regimeDisplay(code) {
  if (!code) return { label: '—', cls: 'regime-none' };
  return {
    label: ADX_REGIME_LABELS[code] || code,
    cls: ADX_REGIME_CLS[code] || 'regime-none',
  };
}

export function spreadTrendArrow(slope) {
  if (slope == null || Number.isNaN(slope)) return '';
  if (slope > 0.05) return ' ↑';
  if (slope < -0.05) return ' ↓';
  return ' →';
}

const FOUR_HOURS = 4 * 3600;

export function chartTimeFromIso(isoStr, timeframe) {
  if (!isoStr) return null;
  if (timeframe === 'daily') {
    return String(isoStr).slice(0, 10);
  }
  const u = Math.floor(new Date(isoStr).getTime() / 1000);
  if (!Number.isFinite(u)) return null;
  if (timeframe === '4h') {
    return Math.floor(u / FOUR_HOURS) * FOUR_HOURS;
  }
  return u;
}

/** OHLC row → lightweight-charts time (matches chartTimeFromIso for indicators). */
export function ohlcChartTime(isoStr, timeframe) {
  return chartTimeFromIso(isoStr, timeframe);
}

/** Markers for DI crosses (ADX > 20 enforced in SQL). */
export function buildDiCrossMarkers(rows, timeframe) {
  const markers = [];
  (rows || []).forEach((row) => {
    const time = chartTimeFromIso(row.time, timeframe);
    if (!time) return;
    if (row.di_cross_bull) {
      markers.push({
        time,
        position: 'belowBar',
        color: row.long_signal ? '#1F4E8C' : 'rgba(31, 78, 140, 0.60)',
        shape: row.long_signal ? 'arrowUp' : 'circle',
        text: row.long_signal ? 'DI+ ADX↑' : 'DI+',
      });
    }
    if (row.di_cross_bear) {
      markers.push({
        time,
        position: 'aboveBar',
        color: '#C0571F',
        shape: 'arrowDown',
        text: 'DI−',
      });
    }
  });
  return markers;
}
